import React, { useState, useRef, useEffect } from 'react';
import { Menu, Layout, Button, Tooltip, Descriptions } from 'antd';
import { Container } from './SidebarThemeStyle';
import {
	DesktopOutlined,
	FileOutlined,
	LogoutOutlined,
	PieChartOutlined,
	TeamOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import {
	checkModulePermissions,
	getFirstAvailableRoute,
} from '../../utils/helper';
import './../../styles/GlobalThemeStyleCQ';
import config from '../../config';
import { getUserRole } from '../../utils/helper';

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = (props) => {
	const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
	const isMobileView = viewportWidth <= 768;
	const organizationLogo = localStorage.getItem('org_logo');
	const [previousPath, setPreviousPath] = useState(null); // Store previous path
	const location = useLocation();
	console.log('getUserRole', getUserRole());

	// Check permissions for various modules
	const dashboardPermission = checkModulePermissions(
		'dashboard',
		'nano-dashboard',
	).authorized;
	const nanodashboardPermission =
		checkModulePermissions('nano-dashboard').authorized;
	const caseManagementPermission =
		checkModulePermissions('case-management').authorized;
	const caseFilingPermission =
		checkModulePermissions('case-filing').authorized;
	const batchesPermission = checkModulePermissions('batch').authorized;
	const openAnalysisPermission =
		checkModulePermissions('open-analysis').authorized;
	const aipaPermission = checkModulePermissions('aipa').authorized;
	const caseAnalysisPermission =
		checkModulePermissions('case-analysis').authorized;
	const maPlanPermission = checkModulePermissions(
		'ma-plan-appeals-processing',
	).authorized;
	const caseClosurePermission =
		checkModulePermissions('case-closure').authorized;
	const voiceAssistancePermission =
		checkModulePermissions('voice-assistance').authorized;
	const codingTeamPermission =
		checkModulePermissions('coding-team').authorized;
	const mdAdvisorPermission = checkModulePermissions('md-advisor').authorized;
	const appealLetterAssignmentPermission = checkModulePermissions(
		'appeal-letter-assignment',
	).authorized;
	const feedbackPermission =
		checkModulePermissions('feedback-analysis').authorized;
	const appealLetterPermission =
		checkModulePermissions('appeal-letter').authorized;
	const shieldMaxx = checkModulePermissions('aipa').authorized;
	const callInsurancePermission =
		checkModulePermissions('call-maxx').authorized;
	// Configuration section permissions
	const userRolePermission =
		checkModulePermissions('user-management').authorized;
	const insuranceCompanyPermission = checkModulePermissions(
		'insurance-company-management',
	).authorized;
	const hospitalPermission = checkModulePermissions(
		'hospital-management',
	).authorized;
	const regionsPermission =
		checkModulePermissions('region-management').authorized;
	const organizationPermission = checkModulePermissions(
		'organization-management',
	).authorized;
	const payerConfigPermission = checkModulePermissions(
		'payer-configuration',
	).authorized;
	const reimbursementsPermission =
		checkModulePermissions('reimbursements').authorized;
	const notificationPermission = getUserRole() === 'super-admin';

	// Check if Case Analytics section should be shown
	const showCaseAnalyticsSection =
		caseManagementPermission ||
		caseFilingPermission ||
		openAnalysisPermission ||
		aipaPermission ||
		caseAnalysisPermission ||
		maPlanPermission ||
		batchesPermission ||
		voiceAssistancePermission;
	// || codingTeamPermission ||
	// mdAdvisorPermission ||
	// appealLetterAssignmentPermission ||
	// feedbackPermission ||
	// caseClosurePermission ||
	// appealLetterPermission;

	// Check if Configuration section should be shown
	const showConfigurationSection =
		insuranceCompanyPermission ||
		hospitalPermission ||
		regionsPermission ||
		organizationPermission ||
		payerConfigPermission ||
		reimbursementsPermission ||
		notificationPermission ||
		userRolePermission;

	// Check if Other Resources section should be shown
	const showOtherResourcesSection =
		codingTeamPermission ||
		mdAdvisorPermission ||
		appealLetterAssignmentPermission ||
		caseClosurePermission ||
		feedbackPermission ||
		appealLetterPermission;

	// Create case management submenu items
	const caseManagementItems = [];

	if (caseManagementPermission) {
		caseManagementItems.push({
			key: 'case-management',
			label: 'Case Details',
			icon: <img src="/images/case-detail.svg" alt="Case Management" />,
		});
	}

	if (caseAnalysisPermission) {
		caseManagementItems.push({
			key: 'case-analysis',
			label: 'Case Analysis',
			icon: (
				<img src="/images/case-analysis-icon.svg" alt="Case Analysis" />
			),
		});
	}

	if (caseFilingPermission) {
		caseManagementItems.push({
			key: 'case-filing',
			label: 'Case Filing',
			icon: <img src="/images/case-filing-icon.svg" alt="Case Filing" />,
		});
	}

	if (maPlanPermission) {
		caseManagementItems.push({
			key: 'ma-plan',
			label: 'MA Plan Appeals',
			icon: (
				<img
					src="/images/ma-appeal-processing-icon.svg"
					alt="MA Plan Appeals"
				/>
			),
		});
	}

	// Dashboard item
	const dashboardItem =
		dashboardPermission || nanodashboardPermission
			? [
					{
						key: 'dashboard',
						icon: (
							<img
								src={'/images/home-icon.svg'}
								alt="Dashboard"
							/>
						),
						label: <Link to={'/'}>Dashboard</Link>,
					},
			  ]
			: [];

	// Case Analytics Section items
	const caseAnalyticsItems = showCaseAnalyticsSection
		? [
				{
					key: 'title-1',
					label: <span className="sidebarTitle">Case Analytics</span>,
					disabled: true,
				},
		  ]
		: [];

	// Create main case management item with children
	if (caseManagementItems.length > 0) {
		caseAnalyticsItems.push({
			key: 'case-management-main',
			icon: (
				<img src="/images/case-management.svg" alt="Case Management" />
			),
			label: 'Case Management',
			children: caseManagementItems.map((item) => ({
				key: item.key,
				icon: item.icon,
				label: (
					<Link
						to={`/${
							item.key === 'case-management'
								? 'case-management'
								: item.key === 'case-analysis'
								? 'case-analysis'
								: item.key === 'case-filing'
								? 'case-filing-management'
								: item.key === 'ma-plan'
								? 'standard-appeal-tat'
								: ''
						}`}
					>
						{item.label}
					</Link>
				),
			})),
		});
	}

	if (batchesPermission) {
		caseAnalyticsItems.push({
			key: 'voice-assistance',
			icon: <img src="/images/agent-maxx.svg" alt="Voice Assistance" />,
			label:
				location.pathname === '/agent-maxx' ||
				location.pathname.startsWith('/agent-maxx/') ||
				location.search ? (
					<a href="/agent-maxx">Agent Maxx</a>
				) : (
					<Link to="/agent-maxx">
						Agent Maxx
						{/* <span className="newBadge">New</span> */}
					</Link>
				),
		});
	}

	if (callInsurancePermission) {
		caseAnalyticsItems.push({
			key: 'call-insurance',
			icon: <img src="/images/call-maxx-icon.svg" alt="Call Insurance" />,
			label: <Link to="/call-insurance">Call Maxx</Link>,
		});
	}
	//TODO if (batchesPermission) {
	// 	caseAnalyticsItems.push({
	// 		key: 'case-agent',
	// 		icon: <img src="/images/agent-maxx.svg" alt="Case Agent" />,
	// 		label: (
	// 			<Link to="/case-agent">
	// 				Agent Max
	// 				{/* <span className="newBadge">New</span> */}
	// 			</Link>
	// 		),
	// 	});
	// }

	// todo if (batchesPermission) {
	// 	caseAnalyticsItems.push({
	// 		key: 'agent-maxx',
	// 		icon: <img src="/images/agent-maxx.svg" alt="agent-maxx" />,
	// 		label: <Link to="/maxx-v1">Maxx v1</Link>,
	// 	});
	// }

	if (batchesPermission) {
		caseAnalyticsItems.push({
			key: 'simulate-ehr',
			icon: <img src="/images/agent-maxx.svg" alt="Simulate EHR" />,
			label: <Link to="/simulate-ehr">Simulate EHR</Link>,
		});
	}

	if (openAnalysisPermission) {
		caseAnalyticsItems.push({
			key: 'open-analysis',
			icon: (
				<img src="/images/open-analysis-icon.svg" alt="Open Analysis" />
			),
			label:
				previousPath === '/open-analysis' ? (
					<a href="/open-analysis">Open Analysis</a>
				) : (
					<Link to="/open-analysis">Open Analysis</Link>
				),
		});
	}

	if (aipaPermission) {
		caseAnalyticsItems.push({
			key: 'aipa',
			icon: <img src="/images/aipa.svg" alt="AIPA" />,
			label:
				previousPath === '/aipa' ? (
					<a href="/aipa">AIPA</a>
				) : (
					<Link to="/aipa">AIPA</Link>
				),
		});
	}

	if (shieldMaxx) {
		caseAnalyticsItems.push({
			key: 'shield-maxx',
			icon: <img src="/images/shield_maxx.svg" alt="shield-maxx" />,
			label: <Link to="/shield-maxx">Shield Maxx</Link>,
		});
	}

	/*
	// Add other case analytics menu items
	if (codingTeamPermission) {
		caseAnalyticsItems.push({
			key: 'coding-team',
			icon: <img src="/images/coding_team.svg" alt="Coding Team" />,
			label: <Link to="/coding-team">Coding Team</Link>,
		});
	}

	if (mdAdvisorPermission) {
		caseAnalyticsItems.push({
			key: 'md-advisor',
			icon: <img src="/images/doctor.svg" alt="MD Advisor" />,
			label: <Link to="/md-advisor">MD Advisor</Link>,
		});
	}

	if (appealLetterAssignmentPermission) {
		caseAnalyticsItems.push({
			key: 'appeal-letter-assignment',
			icon: (
				<img
					src="/images/assign_appeal_letter.svg"
					alt="Assign Appeal Letter"
				/>
			),
			label: (
				<Link to="/appeal-letter-assignment">Assign Appeal Letter</Link>
			),
		});
	}

	if (caseClosurePermission) {
		caseAnalyticsItems.push({
			key: 'case-closure',
			icon: (
				<img src="/images/case-closure-icon.svg" alt="Case Closure" />
			),
			label: <Link to="/case-closure">Case Closure</Link>,
		});
	}

	if (feedbackPermission) {
		caseAnalyticsItems.push({
			key: 'feedback',
			icon: <img src="/images/feedback-icon.svg" alt="Feedback" />,
			label: <Link to="/feedback">Feedback</Link>,
		});
	}

	if (appealLetterPermission) {
		caseAnalyticsItems.push({
			key: 'appeal-letter',
			icon: (
				<img
					src="/images/sidebar-appeal-letter-icon.svg"
					alt="Appeal Letter"
				/>
			),
			label: <Link to="/appeal-letter">Appeal Letter</Link>,
		});
	}
	*/

	// Configuration Section items
	const configurationItems = showConfigurationSection
		? [
				{
					key: 'title-2',
					label: <span className="sidebarTitle">CONFIGURATIONS</span>,
					disabled: true,
				},
		  ]
		: [];

	if (userRolePermission) {
		configurationItems.push({
			key: 'user-role-management',
			icon: (
				<img
					src="/images/user-role-icon.svg"
					alt="User & Role Management"
				/>
			),
			label: (
				<Link to="/user-role-management">User & Role Management</Link>
			),
		});
	}

	if (insuranceCompanyPermission) {
		configurationItems.push({
			key: 'insurance-company',
			icon: (
				<img
					src="/images/insurance-company-menu.svg"
					alt="Insurance Company"
				/>
			),
			label: <Link to="/insurance-company">Insurance Company</Link>,
		});
	}

	if (hospitalPermission) {
		configurationItems.push({
			key: 'hospital',
			icon: <img src="/images/hospital-menu.svg" alt="Hospital" />,
			label: <Link to="/hospital">Hospital</Link>,
		});
	}

	if (regionsPermission) {
		configurationItems.push({
			key: 'regions',
			icon: <img src="/images/regions-menu.svg" alt="Regions" />,
			label: <Link to="/regions">Regions</Link>,
		});
	}

	if (organizationPermission) {
		configurationItems.push({
			key: 'organization',
			icon: (
				<img src="/images/organization-menu.svg" alt="Organization" />
			),
			label: <Link to="/organization">Organization</Link>,
		});
	}

	if (payerConfigPermission) {
		configurationItems.push({
			key: 'payer-configuration',
			icon: (
				<img
					src="/images/payer-configuration-menu.svg"
					alt="Payer Configuration"
				/>
			),
			label: <Link to="/payer-configuration">Payer Configuration</Link>,
		});
	}

	if (reimbursementsPermission) {
		configurationItems.push({
			key: 'reimbursements',
			icon: (
				<img
					src="/images/reimbursements-menu.svg"
					alt="Reimbursements"
				/>
			),
			label: <Link to="/reimbursements">Reimbursements</Link>,
		});
	}

	if (notificationPermission) {
		configurationItems.push({
			key: 'notification-management',
			icon: (
				<img
					src="/images/notifications-management-menu.svg"
					alt="Notifications Management"
				/>
			),
			label: (
				<Link to="/notification-management">
					Notifications Management
				</Link>
			),
		});
	}

	// Other Resources Section items
	const otherResourcesItems = showOtherResourcesSection
		? [
				{
					key: 'title-3',
					label: (
						<span className="sidebarTitle">OTHER RESOURCES</span>
					),
					disabled: true,
				},
		  ]
		: [];

	if (codingTeamPermission) {
		otherResourcesItems.push({
			key: 'coding-team',
			icon: <img src="/images/coding_team.svg" alt="Coding Team" />,
			label: <Link to="/coding-team">Coding Team</Link>,
		});
	}

	if (mdAdvisorPermission) {
		otherResourcesItems.push({
			key: 'md-advisor',
			icon: <img src="/images/doctor.svg" alt="MD Advisor" />,
			label: <Link to="/md-advisor">MD Advisor</Link>,
		});
	}

	if (appealLetterAssignmentPermission) {
		otherResourcesItems.push({
			key: 'appeal-letter-assignment',
			icon: (
				<img
					src="/images/assign_appeal_letter.svg"
					alt="Assign Appeal Letter"
				/>
			),
			label: (
				<Link to="/appeal-letter-assignment">Assign Appeal Letter</Link>
			),
		});
	}

	//Todo Not in use
	// if (caseClosurePermission) {
	// 	otherResourcesItems.push({
	// 		key: 'case-closure',
	// 		icon: (
	// 			<img src="/images/case-closure-icon.svg" alt="Case Closure" />
	// 		),
	// 		label: <Link to="/case-closure">Case Closure</Link>,
	// 	});
	// }

	// if (feedbackPermission) {
	// 	otherResourcesItems.push({
	// 		key: 'feedback',
	// 		icon: <img src="/images/feedback-icon.svg" alt="Feedback" />,
	// 		label: <Link to="/feedback">Feedback</Link>,
	// 	});
	// }

	// if (appealLetterPermission) {
	// 	otherResourcesItems.push({
	// 		key: 'appeal-letter',
	// 		icon: (
	// 			<img
	// 				src="/images/sidebar-appeal-letter-icon.svg"
	// 				alt="Appeal Letter"
	// 			/>
	// 		),
	// 		label: <Link to="/appeal-letter">Appeal Letter</Link>,
	// 	});
	// }

	// Logout item
	const logoutItems = [
		{
			key: 'logout',
			icon: <img src="/images/logout.svg" alt="Logout" />,
			label: <Link to="/logout">Logout</Link>,
		},
	];

	// Combine all menu items
	const items = [
		...dashboardItem,
		...caseAnalyticsItems,
		...configurationItems,
		...otherResourcesItems,
	];

	const keys = [
		{
			pathname: '/',
			key: 'dashboard',
		},
		{
			pathname: '/case-management',
			key: 'case-management',
		},
		{
			pathname: '/user-role-management',
			key: 'user-role-management',
		},
		{
			pathname: '/open-analysis',
			key: 'open-analysis',
		},
		{
			pathname: '/case-analysis',
			key: 'case-analysis',
		},
		{
			pathname: '/case-filing-management',
			key: 'case-filing',
		},
		{
			pathname: '/standard-appeal-tat',
			key: 'ma-plan',
		},
		{
			pathname: '/case-closure',
			key: 'case-closure',
		},
		{
			pathname: '/coding-team',
			key: 'coding-team',
		},
		{
			pathname: '/md-advisor',
			key: 'md-advisor',
		},
		{
			pathname: '/appeal-letter-assignment',
			key: 'appeal-letter-assignment',
		},
		{
			pathname: '/feedback',
			key: 'feedback',
		},
		{
			pathname: '/appeal-letter',
			key: 'appeal-letter',
		},
		{
			pathname: '/insurance-company',
			key: 'insurance-company',
		},
		{
			pathname: '/hospital',
			key: 'hospital',
		},
		{
			pathname: '/regions',
			key: 'regions',
		},
		{
			pathname: '/organization',
			key: 'organization',
		},
		{
			pathname: '/payer-configuration',
			key: 'payer-configuration',
		},
		{
			pathname: '/reimbursements',
			key: 'reimbursements',
		},
		{
			pathname: '/notification-management',
			key: 'notification-management',
		},
		{
			pathname: '/batches',
			key: 'batches',
		},
		{
			pathname: '/aipa',
			key: 'aipa',
		},
		{
			pathname: '/shield-maxx',
			key: 'shield-maxx',
		},
	];

	const updateViewportWidth = () => {
		setViewportWidth(window.innerWidth);
	};

	const handleCollapse = () => {
		if (isMobileView) {
			const newCollapsedState = !props.collapsed;
			props.toggle(newCollapsedState);
			localStorage.setItem(
				'sidebar_collapsed',
				newCollapsedState.toString(),
			);
		}
	};

	useEffect(() => {
		window.addEventListener('resize', updateViewportWidth);
		// Load collapsed state from localStorage when component mounts
		const savedCollapseState = localStorage.getItem('sidebar_collapsed');
		if (savedCollapseState !== null) {
			props.toggle(savedCollapseState === 'true');
		}
		return () => {
			window.removeEventListener('resize', updateViewportWidth);
		};
	}, []);

	// Also update localStorage when collapsed state changes from parent
	useEffect(() => {
		localStorage.setItem('sidebar_collapsed', props.collapsed.toString());
	}, [props.collapsed]);

	// Store the current path before it changes
	useEffect(() => {
		setPreviousPath(location.pathname);
	}, [location]);

	// Find the current selected key based on pathname
	const findSelectedKey = () => {
		const currentPath = location.pathname;
		const matchedKey = keys.find((k) => currentPath.startsWith(k.pathname));
		return matchedKey ? matchedKey.key : 'dashboard';
	};

	return (
		<>
			<Sider
				collapsible
				width={210}
				breakpoint="lg"
				onBreakpoint={(broken) => {
					props.toggle(broken);
				}}
				collapsed={props.collapsed}
				onCollapse={() => {
					const newCollapsedState = !props.collapsed;
					props.toggle(newCollapsedState);
					localStorage.setItem(
						'sidebar_collapsed',
						newCollapsedState.toString(),
					);
				}}
				style={{
					overflow: 'hidden',
					position: 'fixed',
					height: 'calc(100vh - 40px)',
					background: 'transparent',
					left: 0,
					top: '60px',
					bottom: 0,
					zIndex: 1,
					paddingTop: 10,
					background: '#FFF',
					borderRight: props.theme
						? `1px solid ${props.theme.CQColors.borderColor}`
						: '1px solid #e8e8e8',
				}}
				onClick={handleCollapse}
				className="site-layout-background sidebarScroll customScroll pb-5"
			>
				<Container>
					<div
						style={{
							flex: 1,
							overflowY: 'auto',
						}}
					>
						<Menu
							defaultSelectedKeys={[findSelectedKey()]}
							mode="inline"
							overflowedIndicator={
								isMobileView ? (
									<MenuOutlined />
								) : (
									<img
										width={20}
										src="/images/logo-icon.svg"
										alt="Dashboard"
									/>
								)
							}
							onCollapse={handleCollapse}
							items={items}
						/>
					</div>
					{/* <div className="sidebarFooter">
						<Menu
							mode="inline"
							items={logoutItems}
						/>
					</div> */}
				</Container>
				<div className="cover-bar"></div>
			</Sider>
			<div
				className="overlayDrawerClose"
				onClick={() => {
					props.toggle(!props.collapsed);
				}}
			>
				<button className="overlayDrawerCloseBtn btn">&times;</button>
			</div>
		</>
	);
};
export default Sidebar;
